export const MAX_IMAGES_PER_SLIDE = 2;

export interface SlideImageItem {
  svg?: string;
  svgs?: string[];
}

export const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
        return;
      }
      reject(new Error("Could not read file"));
    };
    reader.onerror = () => {
      reject(reader.error ?? new Error("Could not read file"));
    };
    reader.readAsDataURL(file);
  });

export const canPairUploadedImage = (src?: string): boolean =>
  !!src &&
  src.startsWith("data:image/") &&
  !src.startsWith("data:image/svg+xml");

const cleanSources = (sources: Array<string | undefined>): string[] =>
  sources
    .filter((src): src is string => typeof src === "string" && src.trim().length > 0)
    .slice(0, MAX_IMAGES_PER_SLIDE);

export const getSlideImages = (item: SlideImageItem): string[] => {
  const paired = cleanSources(item.svgs ?? []);
  if (paired.length > 1) {
    return paired;
  }

  const primary = item.svg?.trim();
  if (primary) {
    return [primary];
  }

  return paired;
};

export const slideImageFields = (
  primary?: string,
  secondary?: string,
): { svg?: string; svgs?: string[] } => {
  const images = cleanSources([primary, secondary]);
  if (images.length === 0) {
    return { svg: undefined, svgs: undefined };
  }
  if (images.length === 1) {
    return { svg: images[0], svgs: undefined };
  }
  return { svg: images[0], svgs: images };
};
